// @flow
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import NavBar from '../../components/nav-bar';
import Footer from '../../components/footer';
import { Page } from './home.styles';
import ProposalPage from '../proposal';
import FeedPage from '../feed';
import ErrorPage from '../error';

type Props = {
  isAuthenticated: boolean,
};

export default class HomePage extends Component {
  state = {};

  props: Props;

  render() {
    return (
      <div>
        <NavBar
          onCreateProposal={() => this.props.history.push('/proposal')}
          onLogoClick={() => this.props.history.push('/')}
        />
        <Page>
          <Switch>
            <Route exact path="/" component={FeedPage} />
            <Route exact path="/proposal/:id?" component={ProposalPage} />
            <Route component={ErrorPage} />
          </Switch>
        </Page>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/index.js